import React from "react";

const Step3Schedule = ({
                           selectedPatient,
                           selectedContent,
                           scheduleOption,
                           setScheduleOption,
                           goToStep,
                       }) => {
    const options = [
        {
            id: "now",
            label: "Disponible inmediatamente",
            description: "El paciente podrá ver el contenido tan pronto como reciba la notificación",
        },
        {
            id: "date",
            label: "Programar para una fecha específica",
            description: "El contenido estará disponible a partir de una fecha determinada",
        },
        {
            id: "after",
            label: "Después de completar otro contenido",
            description: "El paciente deberá completar otro contenido previamente asignado",
        },
    ];

    return (
        <div className="step active">
            <div className="section">
                <h2 className="section-title">
                    <span className="number">3</span> Programar visualización
                </h2>

                <div className="patient-item selected">
                    <div className="patient-name">{selectedPatient?.fullName}</div>
                    <div className="patient-details">{selectedPatient?.email}</div>
                </div>

                <div className="content-item selected">
                    <div className="content-thumbnail">
                        <span>{selectedContent?.icon || "▶️"}</span>
                    </div>
                    <div className="content-details">
                        <div className="content-title">{selectedContent?.title}</div>
                        <div className="content-meta">
                            <span className="content-tag">{selectedContent?.tag}</span>
                            <span>{selectedContent?.duration}</span>
                        </div>
                    </div>
                </div>

                <div className="schedule-options">
                    {options.map((opt) => (
                        <div
                            key={opt.id}
                            className={`schedule-option ${scheduleOption === opt.id ? "selected" : ""}`}
                            onClick={() => setScheduleOption(opt.id)}
                        >
                            <div className="radio-button"></div>
                            <div>
                                <div className="option-label">{opt.label}</div>
                                <div className="option-description">{opt.description}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="sticky-footer">
                <div className="progress-indicator">
                    <div className="progress-dot active"></div>
                    <div className="progress-dot active"></div>
                    <div className="progress-dot active"></div>
                </div>
                <button
                    className="action-button"
                    disabled={!scheduleOption}
                    onClick={() => goToStep(4)}
                >
                    Asignar contenido
                </button>
            </div>
        </div>
    );
};

export default Step3Schedule;
